import e from"./NumericMenu.vue_vue&type=script&lang.js";import{render as r}from"./NumericMenu.vue_vue&type=template&id=ada9761c&lang.js";e.render=r;export default e;
//# sourceMappingURL=NumericMenu.vue.js.map
